 const Button = ({
  children,
  onClick,
  className = '',
  variant = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
}) => {
  let baseClasses =
    "font-bold py-2 px-4 rounded-lg shadow-md transition duration-300 transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 ";

  if (variant === 'primary') {
    baseClasses += "bg-indigo-600 hover:bg-indigo-700 text-white";
  } else if (variant === 'secondary') {
    baseClasses += "bg-gray-200 hover:bg-gray-300 text-gray-800";
  } else if (variant === 'danger') {
    baseClasses += "bg-red-600 hover:bg-red-700 text-white";
  } else if (variant === 'success') {
    baseClasses += "bg-green-600 hover:bg-green-700 text-white";
  }

  if (disabled || loading) {
    baseClasses =
      "bg-gray-400 text-gray-600 font-bold py-2 px-4 rounded-lg cursor-not-allowed flex items-center justify-center gap-2";
  }

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${className}`}
      type={type}
      disabled={disabled || loading}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin h-5 w-5 text-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          <span>Processing...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};
export { Button };
